var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fetchDiffs.length),
      expression: "fetchDiffs.length"
    }],
    staticClass: "section-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fetchDiffs.length),
      expression: "fetchDiffs.length"
    }]
  }, [_vm._v("\n      The following data is out of sync:\n      "), _vm._l((_vm.fetchDiffs), function(diff) {
    return _c('p', {
      on: {
        "click": function($event) {
          _vm.visit(diff.id)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [(_vm.localDiffs.includes(diff.id)) ? _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.$root.syncLocal($event)
        }
      }
    }, [_vm._v("Local")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sync(diff.id)
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.discard(diff.id)
        }
      }
    }, [_vm._v("Discard")])]), _vm._v("\n        " + _vm._s(diff.id) + "\n        "), _c('br'), _c('small', [_vm._v(_vm._s(Object.keys(diff.diff).join(', ')))])])
  })], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-367c65ed","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSync.vue
// module id = 35
// module chunks = 1